// Page Me — the six devices (IDEATION "Devices"). Invented names only.
//
// `shell` and `silk` are CSS custom-property NAMES defined in src/styles/app.css;
// a component uses them as `var(${device.shell})`. No colours here.

export const DEVICES = Object.freeze([
  {
    id: 'buzz12', name: 'BUZZ 12', year: 1991, family: 'numeric',
    lines: 1, cols: 12, lcd: 'classic', font: 'seg',
    shell: '--shell-buzz12', silk: '--silk', beep: 'classic',
    spec: 'SCREEN: 1 LINE, 12 DIGITS',
    blurb: 'The belt-clip brick. Numbers only, and it never misses a beep.',
    locked: false,
  },
  {
    id: 'topaz', name: 'TOPAZ', year: 1995, family: 'alpha',
    lines: 1, cols: 16, lcd: 'classic', font: 'dot',
    shell: '--shell-topaz', silk: '--silk', beep: 'chirp',
    spec: 'SCREEN: 1 LINE, 16 CHARACTERS',
    blurb: 'See-through teal. Your pages scroll past like a stock ticker.',
    locked: false,
  },
  {
    id: 'memo', name: 'MEMO FLIP', year: 1996, family: 'alpha',
    lines: 4, cols: 20, lcd: 'classic', font: 'dot',
    shell: '--shell-memo', silk: '--silk', beep: 'classic',
    spec: 'SCREEN: 4 LINES, 20 CHARACTERS',
    blurb: 'Flip the lid, read the whole page. Very executive.',
    locked: false,
  },
  {
    id: 'thumb950', name: 'THUMB 950', year: 1998, family: 'twoway',
    lines: 8, cols: 28, lcd: 'blue', font: 'dot',
    shell: '--shell-thumb950', silk: '--silk', beep: 'twoway',
    spec: 'SCREEN: 8 LINES, 28 CHARACTERS',
    blurb: 'The puck with a thumb keyboard. Two-way paging, finally.',
    locked: false,
  },
  {
    id: 'thumb957', name: 'THUMB 957', year: 2000, family: 'twoway',
    lines: 16, cols: 30, lcd: 'blue', font: 'dot',
    shell: '--shell-thumb957', silk: '--silk-dark', beep: 'twoway',
    spec: 'SCREEN: 16 LINES, 30 CHARACTERS',
    blurb: 'Tall silver slab with a side wheel. Whole conversations at once.',
    locked: false,
  },
  {
    id: 'track8700', name: 'TRACKBALL 8700', year: 2005, family: 'twoway',
    lines: 12, cols: 32, lcd: 'color', font: 'color',
    shell: '--shell-track8700', silk: '--silk', beep: 'ping',
    spec: 'SCREEN: COLOUR, 12 LINES',
    blurb: 'A colour screen and a trackball. The end of the pager era.',
    locked: false,
  },
]);

export const DEFAULT_DEVICE = 'buzz12';

/** The device with this id, or BUZZ 12 for anything unknown. */
export function deviceById(id) {
  return DEVICES.find((d) => d.id === id) ?? DEVICES[0];
}
